import { Box, Icon, IconButton, Text, SimpleGrid } from "@chakra-ui/react";
import { ReactComponent as Room1Svg } from "../../Icons/room1.svg";
import { ReactComponent as Room2Svg } from "../../Icons/room2.svg";
import { ReactComponent as Room3Svg } from "../../Icons/room3.svg";
import {
  useModelStore,
  useRoomStore,
  useUserInterfaceStore,
} from "../../store";
import { useEffect, useState } from "react";
import { fitCameraToBox, resetCameraControls } from "../../constants/Helpers";

const RoomCard = ({ SvgIcon, label, size, isSelected, onSelect }) => {
  const setScaleX = useRoomStore((s) => s.setScaleX);
  const setScaleZ = useRoomStore((s) => s.setScaleZ);
  const setHeight = useRoomStore((s) => s.setHeight);

  const handleClick = () => {
    setScaleX(size.x);
    setScaleZ(size.z);
    setHeight(size.y);
    onSelect({ label, size });
  };

  return (
    <Box
      onClick={handleClick}
      background="#1A1A1A"
      border="4px solid"
      borderColor={isSelected ? "#FFF" : "#1A1A1A"}
      _hover={{ borderColor: "#FFF" }}
      textAlign="center"
      cursor="pointer"
    >
      <IconButton
        aria-label={label}
        w={{ base: "120px", md: "220px" }}
        h={{ base: "75px", md: "135px" }}
        m={{ base: "8px", md: "16px" }}
      >
        <Icon>
          <SvgIcon
            style={{
              width: "100%",
              height: "100%"
            }}
          />
        </Icon>
      </IconButton>
      <Text
        color="#FFF"
        fontFamily="DM Mono"
        fontSize="20px" // Reduced from 24px
        fontWeight="400"
        lineHeight="normal"
      >
        {label}
      </Text>
    </Box>
  );
};

function RoomSelectionPanel() {
  const [selectedRoom, setSelectedRoom] = useState({
    label: "10x10x5",
    size: { x: 100, y: 50, z: 100 },
  });
  const setEditingRoom = useUserInterfaceStore((s) => s.setEditingRoom);

  const cameraControls = useModelStore((s) => s.cameraControls);
  const lockCameraForEditor = useUserInterfaceStore(
    (s) => s.lockCameraForEditor
  );
  // const editingRoom = useUserInterfaceStore((s) => s.editingRoom);
  useEffect(() => {
    setEditingRoom(false);
    resetCameraControls(cameraControls, lockCameraForEditor);
  }, [cameraControls, lockCameraForEditor, setEditingRoom]);

  useEffect(
    () => {
      if (cameraControls) {
        fitCameraToBox(cameraControls, selectedRoom.size);
      }
    }
    // [selectedRoom, cameraControls]
  );

  return (
    <SimpleGrid columns={{ base: 2, md: 1 }} gap={{ base: "3", md: "4" }} justifyItems="center">
      <RoomCard
        SvgIcon={Room1Svg}
        label="10x10x5"
        size={{ x: 100, y: 50, z: 100 }}
        isSelected={selectedRoom === "10x10x5"}
        onSelect={setSelectedRoom}
      />
      <RoomCard
        SvgIcon={Room2Svg}
        label="5x10x5"
        size={{ x: 50, y: 50, z: 100 }}
        isSelected={selectedRoom === "5x10x5"}
        onSelect={setSelectedRoom}
      />
      <RoomCard
        SvgIcon={Room3Svg}
        label="10x10x10"
        size={{ x: 100, y: 100, z: 100 }}
        isSelected={selectedRoom === "10x10x10"}
        onSelect={setSelectedRoom}
      />
      {/* Empty placeholder for mobile 2x2 grid */}
      <Box display={{ base: "block", md: "none" }} />
    </SimpleGrid>
  );
}

export default RoomSelectionPanel;
